<template>
<modal
    :title="`Form Preview: ${name}`"
    ref="modal_form_preview"
    stretch
>
    <content-header :links="[
        {
            label: Pages.FORM,
            active: current_page === Pages.FORM,
            on_click: setCurrentPage,
            on_click_params: [Pages.FORM],
        },
        {
            label: Pages.PEOPLE,
            active: current_page === Pages.PEOPLE,
            on_click: setCurrentPage,
            on_click_params: [Pages.PEOPLE],
            hide: !form.add_operative_with_signature,
        },
        {
            label: Pages.SIGNATURE,
            active: current_page === Pages.SIGNATURE,
            on_click: setCurrentPage,
            on_click_params: [Pages.SIGNATURE],
            hide: !form.signature,
        },
        {
            label: Pages.IMAGES,
            active: current_page === Pages.IMAGES,
            on_click: setCurrentPage,
            on_click_params: [Pages.IMAGES],
            hide: !form.photos,
        },
        {
            label: Pages.COMMENTS,
            active: current_page === Pages.COMMENTS,
            on_click: setCurrentPage,
            on_click_params: [Pages.COMMENTS],
            hide: !form.additional_comments,
        },
    ]" />

    <div
        class="tab-content"
        id="formPreviewContent"
    >
        <modal-tab-content
            tab_name="Form"
            :selected="isActivePage(Pages.FORM)"
        >
            <template>
                <form-submittable-questions
                    v-for="question in form.questions"
                    :key="question.id"
                    :question="question"
                    :request_form="request_form"
                    @update-value="updateValue"
                />
            </template>
        </modal-tab-content>

        <modal-tab-content
            v-if="form.add_operative_with_signature"
            tab_name="People"
            :selected="isActivePage(Pages.PEOPLE)"
        >
            <template>
                <form-submittable-people
                    :people="[
                        {
                            id: 1,
                            name: 'John Doe',
                            email: 'john.doe@underconstruction.co.uk',
                        },
                        {
                            id: 2,
                            name: 'Jane Doe',
                            email: 'jane.doe@underconstruction.co.uk',
                        },
                        {
                            id: 3,
                            name: 'John Smith',
                            email: 'john.smith@underconstruction.co.uk',
                        },
                        {
                            id: 4,
                            name: 'Jane Smith',
                            email: 'jane.smith@underconstruction.co.uk',
                        },
                    ]"
                    @update-value="updateValue"
                />
            </template>
        </modal-tab-content>

        <modal-tab-content
            v-if="form.signature"
            tab_name="Signature"
            :selected="isActivePage(Pages.SIGNATURE)"
        >
            <template>
                <div class="d-flex justify-content-center mb-3">
                    <form-submittable-signature
                        ref="signature-canvas"
                        @update-value="updateValue"
                    />
                </div>
            </template>
        </modal-tab-content>

        <modal-tab-content
            v-if="form.photos"
            tab_name="Images"
            :selected="isActivePage(Pages.IMAGES)"
        >
            <template>
                <form-submittable-images
                    :request_form="request_form"
                    @update-value="updateValue"
                />
            </template>
        </modal-tab-content>

        <modal-tab-content
            v-if="form.additional_comments"
            tab_name="Comments"
            :selected="isActivePage(Pages.COMMENTS)"
        >
            <template>
                <form-submittable-comments
                    :request_form="request_form"
                    @update-value="updateValue"
                />
            </template>
        </modal-tab-content>

        <button class="w-100 btn btn-positive">Submit Form</button>
    </div>

    <template #close-button>
        <button
            type="button"
            class="btn btn-primary"
        >
            Close Preview
        </button>
    </template>
</modal>
</template>

<script>
import ContentHeader from "../general_components/ContentHeader.vue";
import Modal from "../general_components/Modal.vue";
import ModalTabContent from "../general_components/ModalTabContent.vue";
import FormSubmittableQuestions from "./submittable/FormSubmittableQuestions.vue";
import FormSubmittablePeople from "./submittable/FormSubmittablePeople.vue";
import FormSubmittableSignature from "./submittable/FormSubmittableSignature.vue";
import FormSubmittableImages from "./submittable/FormSubmittableImages.vue";
import FormSubmittableComments from "./submittable/FormSubmittableComments.vue";

const PagesEnum = Object.freeze({
    FORM: 'FORM',
    PEOPLE: 'PEOPLE',
    SIGNATURE: 'SIGNATURE',
    IMAGES: 'IMAGES',
    COMMENTS: 'COMMENTS',
});

export default {
    name: "FormPreviewModal",
    components: {
        ContentHeader,
        Modal,
        ModalTabContent,
        FormSubmittableQuestions,
        FormSubmittablePeople,
        FormSubmittableSignature,
        FormSubmittableImages,
        FormSubmittableComments,
    },
    props: {
        form: Object,
        name: String,
    },
    data() {
        return {
            current_page: PagesEnum.FORM,
            Pages: PagesEnum,
            request_form: {},
        };
    },
    watch: {
        current_page() {
            if (this.current_page === PagesEnum.SIGNATURE) {
                const signature_canvas = this.$refs['signature-canvas'];

                if (signature_canvas.isSignatureEmpty()) {
                    setTimeout(() => {
                        signature_canvas.resizeCanvas();
                    }, 100);
                }
            }
        },
    },
    methods: {
        setCurrentPage(page) {
            this.current_page = page;
        },
        isActivePage(page_name) {
            return this.current_page === page_name;
        },
        open() {
            this.$nextTick(function () {
                this.$refs.modal_form_preview.openModal();
            });
        },
        updateValue(id, value) {
            this.$set(this.request_form, id, value);
        },
    },
};
</script>
